import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class UrlList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            previewServer: util.getPreviewServer(),
        };
        this.updateTimer = {};

        const { urlStore } = this.props.stores;
        urlStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { urlStore } = this.props.stores;
        const { totalAppend, limit } = urlStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = urlStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                urlStore.updateOffset(offset);
                await urlStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { urlStore } = this.props.stores;
        urlStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { urlStore } = this.props.stores;
        await urlStore.saveField(id, field, value);
    }

    render() {
        const { loading, previewServer } = this.state;
        const { urlStore } = this.props.stores;
        const { urls, queryFilter, saved } = urlStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {urlStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for urls...'
                                    onInput={e => urlStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => urlStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {urlStore.total || 0} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => urlStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {urlStore.sort !== urlStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => urlStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 15%'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('title', '-')}>
                                                Title {util.getSortIcon('title', urlStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('alias', '-')}>
                                                Alias {util.getSortIcon('alias', urlStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('source', '-')}>
                                                Source {util.getSortIcon('source', urlStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('tags', '')}>
                                                Tags {util.getSortIcon('tags', urlStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 50%'>Url</th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('clicks', '')}>
                                                Clicks {util.getSortIcon('clicks', urlStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => urlStore.toggleSort('created', '')}>
                                                Created {util.getSortIcon('created', urlStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {urls && urls.map(article => (
                                        <tr class={`${style.tableline}`}>
                                            <td>
                                                <a href={`/urls/${article.id}/Basics`}>{article.title}</a>
                                            </td>
                                            <td>
                                                <nobr>
                                                    <a target='_blank' href={`${previewServer}/go/${article.alias}`}>
                                                        <i class='fas fa-link' /> {article.alias}
                                                    </a>
                                                </nobr>
                                            </td>
                                            <td>
                                                {article.source}
                                            </td>
                                            <td>
                                                {article.tags}
                                            </td>
                                            <td>
                                                {article.url}
                                            </td>

                                            <td class='text-right'>
                                                {article.clicks}
                                            </td>
                                            <td class='text-right'>
                                                {article.created && util.ffeDateTime(article.created)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default UrlList;




// WEBPACK FOOTER //
// ./components/urls/list.js